module.exports = __webpack_public_path__ + "img/new_14.562491f3.jpg";